import React from 'react';

import Header from './Header';
import {disciplines} from './constants';

const DisciplineTips2 = ({score}) => {
    const discipline = disciplines['2'];

    return (
        <div className={'ohs-discipline'}>
            <Header/>

            <div className={'ohs-discipline__content ohs-content-padding'}>
                <h2 className={'ohs-discipline__heading'}>{discipline.header}</h2>

                <p className={'ohs-discipline__score-text'}>{discipline[score]}</p>

                <h3 className={'ohs-discipline__tips-heading'}>Tips for Creating Clarity:</h3>
                <p className={'ohs-discipline__tips-intro'}>
                    Ask the team to discuss and come to a resolution around the questions below (which may vary somewhat
                    depending on the nature of the team and its place in the organization). Before moving on, make
                    certain that each team member has the same understanding of what has been agreed to.
                </p>

                <div className={'ohs-discipline__questions'}>
                    <p className={'ohs-discipline__questions-label'}>Questions include:</p>
                    <ol className={'ohs-discipline__questions-list'}>
                        <li><b>Why do we exist?</b></li>
                        <li><b>How do we behave?</b></li>
                        <li><b>What do we do?</b></li>
                        <li><b>How will we succeed?</b></li>
                        <li><b>What is most important &mdash; right now?</b></li>
                        <li><b>Who must do what?</b></li>
                    </ol>
                </div>

                <p className={'ohs-discipline__reference'}>
                    If you need more detailed information on establishing a thematic goal, refer to the book{' '}
                    <i>Silos, Politics and Turf Wars</i>:{' '}
                    <a className={'ohs-discipline__link'} href='https://www.tablegroup.com/silos/'>
                        www.tablegroup.com/silos
                    </a>.
                </p>
            </div>
        </div>
    );
};

export default DisciplineTips2;
